import { Injectable } from '@angular/core';
import { EntityState, EntityStore, Store, StoreConfig } from '@datorama/akita';
import {
    ComponentSettings,
    ComponentSettingsKey,
    GlobalSettings,
    RouteSettings
} from './user-setting.model';

export type GlobalUIState = Partial<{
    [Property in keyof GlobalSettings]: SettingsUI;
}>;
export interface RouteSettingsState extends EntityState<RouteSettings, string> {}
export interface ComponentSettingsState extends EntityState<ComponentSettings, string> {}

export type SettingsUI = { status: 'PENDING' | 'SAVED' };
export type SettingsUIStatus = SettingsUI['status'];
export type SettingsUIState<K extends ComponentSettingsKey = ComponentSettingsKey> = {
    [key in ComponentSettingsKey]: {
        [key: string]: SettingsUI;
    };
};
@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'user-settings-global', idKey: 'key', resettable: true })
export class UserSettingsStore extends Store<
    GlobalSettings & {
        ui?: GlobalUIState;
        loading?: boolean;
        error?: any;
    }
> {
    ROUTE = new EntityStore<RouteSettingsState>({}, { name: 'user-settings-route' });
    COMPONENT = new EntityStore<ComponentSettingsState>(
        {},
        { name: 'user-settings-component' }
    );
    constructor() {
        super({});
        this.COMPONENT.createUIStore();
        this.ROUTE.createUIStore();
    }
}
